import type { Notification } from '../data/types';

/**
 * Ce qu'on affiche pour chaque genre de notification. Le libellé sert de
 * repère dans la cloche : deux mots, jamais une phrase.
 */
const LIBELLES: Record<string, string> = {
  decision_demandee: 'À décider',
  decision_rendue: 'Décision',
  tache_attribuee: 'Pour toi',
  chiffrage_demande: 'Chiffrage',
  montant_recu: 'Montant reçu',
  escalade: 'Escalade',
  relais_recu: 'Relais',
  relais_info: 'Relais',
  relais_termine: 'Relais terminé',
  mention: 'Message',
  message: 'Message',
  probleme: 'Problème',
  offre_a_venir: 'Offre à venir',
  echeance_j2: 'Dans deux jours',
  echeance_jour: "Aujourd'hui",
  point_echu: 'Point à faire',
  sans_nouvelles: 'Sans nouvelles',
  compte_rendu_demande: 'Compte rendu',
};

export function libelleGenre(genre: string): string {
  return LIBELLES[genre] ?? 'ALBA';
}

/**
 * L'écran ouvert par une notification. Même règle que côté serveur
 * (`alba.lien_notification`) : le tap doit tomber là où l'action se fait.
 */
export function lienNotification(notification: Notification): string {
  const genre = notification.kind;
  if (genre === 'decision_demandee' || genre === 'montant_recu' || genre === 'escalade') {
    return '/a-decider';
  }
  if (genre === 'mention') return '/fil';
  if (notification.task_id) return `/tableau?tache=${notification.task_id}`;
  return '/tableau';
}

/** « à l'instant », « il y a 12 min », « hier », « 14 août ». */
export function ilYA(iso: string, maintenant: Date = new Date()): string {
  const date = new Date(iso);
  const minutes = Math.floor((maintenant.getTime() - date.getTime()) / 60000);
  if (minutes < 1) return 'à l’instant';
  if (minutes < 60) return `il y a ${minutes} min`;
  const heures = Math.floor(minutes / 60);
  if (heures < 24) return `il y a ${heures} h`;
  const jours = Math.floor(heures / 24);
  if (jours === 1) return 'hier';
  if (jours < 7) return `il y a ${jours} jours`;
  return new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'long' }).format(date);
}
